import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
const KeyboardAwareScrollView = () => {
    return _jsx(_Fragment, {});
};
export default KeyboardAwareScrollView;
